{
  "asyncapi": "3.1.0",
  "info": {
    "title": "Springwolf example project - STOMP",
    "version": "1.0.0",
    "description": "Springwolf [example project](https://github.com/springwolf/springwolf-core/tree/main/springwolf-examples/springwolf-stomp-example) to demonstrate springwolfs abilities, including **markdown** support for descriptions.",
    "termsOfService": "https://asyncapi.org/terms",
    "contact": {
      "name": "springwolf",
      "url": "https://github.com/springwolf/springwolf-core",
      "email": "example@example.com"
    },
    "license": {
      "name": "Apache License 2.0"
    },
    "x-generator": "springwolf"
  },
  "defaultContentType": "application/json",
  "servers": {
    "stomp": {
      "host": "localhost:8080/myendpoint",
      "protocol": "stomp"
    }
  },
  "channels": {
    "_app_queue_another-queue": {
      "address": "/app/queue/another-queue",
      "messages": {
        "io.github.springwolf.examples.stomp.dtos.AnotherPayloadDto": {
          "$ref": "#/components/messages/io.github.springwolf.examples.stomp.dtos.AnotherPayloadDto"
        }
      },
      "bindings": { }
    },
    "_app_queue_example-queue": {
      "address": "/app/queue/example-queue",
      "messages": {
        "io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto": {
          "$ref": "#/components/messages/io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto"
        }
      },
      "bindings": {
        "stomp": { }
      }
    },
    "_app_queue_sendto-queue": {
      "address": "/app/queue/sendto-queue",
      "messages": {
        "io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto": {
          "$ref": "#/components/messages/io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto"
        }
      },
      "bindings": {
        "stomp": { }
      }
    },
    "_app_queue_sendtouser-queue": {
      "address": "/app/queue/sendtouser-queue",
      "messages": {
        "io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto": {
          "$ref": "#/components/messages/io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto"
        }
      },
      "bindings": {
        "stomp": { }
      }
    },
    "_app_topic_sendto-response-queue": {
      "address": "/app/topic/sendto-response-queue",
      "messages": {
        "io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto": {
          "$ref": "#/components/messages/io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto"
        }
      },
      "bindings": {
        "stomp": { }
      }
    },
    "_user_queue_sendtouser-response-queue": {
      "address": "/user/queue/sendtouser-response-queue",
      "messages": {
        "io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto": {
          "$ref": "#/components/messages/io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto"
        }
      },
      "bindings": {
        "stomp": { }
      }
    }
  },
  "components": {
    "schemas": {
      "HeadersNotDocumented": {
        "title": "HeadersNotDocumented",
        "type": "object",
        "properties": { },
        "description": "There can be headers, but they are not explicitly documented.",
        "examples": [
          { }
        ]
      },
      "SpringStompDefaultHeaders": {
        "title": "SpringStompDefaultHeaders",
        "type": "object",
        "properties": { },
        "examples": [
          { }
        ]
      },
      "io.github.springwolf.examples.stomp.dtos.AnotherPayloadDto": {
        "title": "AnotherPayloadDto",
        "type": "object",
        "properties": {
          "example": {
            "$ref": "#/components/schemas/io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto"
          },
          "foo": {
            "type": "string",
            "description": "Foo field",
            "maxLength": 100,
            "examples": [
              "bar"
            ]
          }
        },
        "description": "Another payload model",
        "examples": [
          {
            "example": {
              "someEnum": "FOO2",
              "someLong": 5,
              "someString": "some string value"
            },
            "foo": "bar"
          }
        ],
        "required": [
          "example"
        ]
      },
      "io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto": {
        "title": "ExamplePayloadDto",
        "type": "object",
        "properties": {
          "someEnum": {
            "title": "ExampleEnum",
            "type": "string",
            "description": "Some enum field",
            "enum": [
              "FOO1",
              "FOO2",
              "FOO3"
            ],
            "examples": [
              "FOO2"
            ]
          },
          "someLong": {
            "type": "integer",
            "description": "Some long field",
            "format": "int64",
            "minimum": 0,
            "examples": [
              5
            ]
          },
          "someString": {
            "type": "string",
            "description": "Some string field",
            "examples": [
              "some string value"
            ]
          }
        },
        "description": "Example payload model",
        "examples": [
          {
            "someEnum": "FOO2",
            "someLong": 5,
            "someString": "some string value"
          }
        ],
        "required": [
          "someEnum",
          "someString"
        ]
      }
    },
    "messages": {
      "io.github.springwolf.examples.stomp.dtos.AnotherPayloadDto": {
        "headers": {
          "$ref": "#/components/schemas/HeadersNotDocumented"
        },
        "payload": {
          "schemaFormat": "application/vnd.aai.asyncapi+json;version=3.1.0",
          "schema": {
            "$ref": "#/components/schemas/io.github.springwolf.examples.stomp.dtos.AnotherPayloadDto"
          }
        },
        "name": "io.github.springwolf.examples.stomp.dtos.AnotherPayloadDto",
        "title": "AnotherPayloadDto",
        "bindings": {
          "stomp": { }
        }
      },
      "io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto": {
        "headers": {
          "$ref": "#/components/schemas/SpringStompDefaultHeaders"
        },
        "payload": {
          "schemaFormat": "application/vnd.aai.asyncapi+json;version=3.1.0",
          "schema": {
            "$ref": "#/components/schemas/io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto"
          }
        },
        "name": "io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto",
        "title": "ExamplePayloadDto",
        "bindings": {
          "stomp": { }
        }
      }
    }
  },
  "operations": {
    "_app_queue_another-queue_send_sendMessage": {
      "action": "send",
      "channel": {
        "$ref": "#/channels/_app_queue_another-queue"
      },
      "title": "_app_queue_another-queue_send",
      "description": "Custom, optional description defined in the AsyncPublisher annotation",
      "bindings": {
        "stomp": { }
      },
      "messages": [
        {
          "$ref": "#/channels/_app_queue_another-queue/messages/io.github.springwolf.examples.stomp.dtos.AnotherPayloadDto"
        }
      ]
    },
    "_app_queue_example-queue_receive_receiveExamplePayload": {
      "action": "receive",
      "channel": {
        "$ref": "#/channels/_app_queue_example-queue"
      },
      "bindings": {
        "stomp": { }
      },
      "messages": [
        {
          "$ref": "#/channels/_app_queue_example-queue/messages/io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto"
        }
      ]
    },
    "_app_queue_sendto-queue_receive_receiveExamplePayloadSendTo": {
      "action": "receive",
      "channel": {
        "$ref": "#/channels/_app_queue_sendto-queue"
      },
      "bindings": {
        "stomp": { }
      },
      "messages": [
        {
          "$ref": "#/channels/_app_queue_sendto-queue/messages/io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto"
        }
      ],
      "reply": {
        "channel": {
          "$ref": "#/channels/_app_topic_sendto-response-queue"
        },
        "messages": [
          {
            "$ref": "#/channels/_app_topic_sendto-response-queue/messages/io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto"
          }
        ]
      }
    },
    "_app_queue_sendtouser-queue_receive_receiveExamplePayloadSendToUser": {
      "action": "receive",
      "channel": {
        "$ref": "#/channels/_app_queue_sendtouser-queue"
      },
      "bindings": {
        "stomp": { }
      },
      "messages": [
        {
          "$ref": "#/channels/_app_queue_sendtouser-queue/messages/io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto"
        }
      ],
      "reply": {
        "channel": {
          "$ref": "#/channels/_user_queue_sendtouser-response-queue"
        },
        "messages": [
          {
            "$ref": "#/channels/_user_queue_sendtouser-response-queue/messages/io.github.springwolf.examples.stomp.dtos.ExamplePayloadDto"
          }
        ]
      }
    }
  }
}